declare global {
  const Conword: {
    get_available_languages: () => Record<string, { name: string }>;
    translate(lang: string): void;
    get_current_language(): string;
  };
}

const iconHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
  <path d="M0 0h24v24H0z" fill="none" />
  <path fill="currentColor" d="M17.9 17.39c-.26-.8-1.01-1.39-1.9-1.39h-1v-3a1 1 0 0 0-1-1H8v-2h2a1 1 0 0 0 1-1V7h2a2 2 0 0 0 2-2v-.41a7.984 7.984 0 0 1 2.9 12.8M11 19.93c-3.95-.49-7-3.85-7-7.93c0-.62.08-1.22.21-1.79L9 15v1a2 2 0 0 0 2 2m1-16A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2" />
</svg>`;

document.addEventListener('Conword:ready', function () {
  window
    .once<HTMLElement>('language-switcher', '.js-language-switcher')
    .forEach(el => {
      const currLang = Conword.get_current_language();
      const selectEl = document.createElement('select');
      selectEl.classList.add('select__select');
      el.innerHTML = iconHTML;

      const languages = Conword.get_available_languages();

      for (let [langKey, langDef] of Object.entries(languages)) {
        const optionEl = document.createElement('option');
        optionEl.text = langDef.name;
        optionEl.value = langKey;
        selectEl.append(optionEl);
      }

      selectEl.value = currLang;
      el.classList.add('select');
      el.append(selectEl);

      // add event listener
      selectEl.addEventListener('change', e => {
        // @ts-expect-error
        const value = e.target.value;

        Conword.translate(value);
      });

      document.addEventListener('Conword:translation_started', () => {
        const lang = Conword.get_current_language();

        document
          .querySelectorAll<HTMLOptionElement>(`.js-language-switcher select`)
          .forEach(select => {
            select.value = lang;
          });
      });
    });
});

export {};
